module.exports = __webpack_public_path__ + "img/ic_20_apple.3fbcbbb6.svg";